import { Row } from "react-bootstrap";
import { useParams, useSearchParams } from "react-router-dom";
import { useCallback } from "react";

import { useGetShipmentInvoices } from "api/queries/invoice/useGetShipmentInvoices";
import PillTabs from "components/atoms/PillTabs/PillTabs";
import Badge from "components/atoms/Badge/Badge";
import useCustomBrokerPermission from "hooks/useCustomBrokerPermission";
import { InvoiceStatusColors } from "../../../../../constants";

const INVOICE_BADGE_SOLID_COLOR: any = {
  "Awaiting Audit": "#F1B92A",
  Approved: "#9EC728",
  Declined: "#EA7939",
} as const;

const invoiceSelector = (data: any, isCustomBroker: boolean) => {
  if (isCustomBroker) {
    return data.results.filter((item: any) => item.invoice_type === "customs_broker_invoice");
  }
  return data.results;
};

const initialInvoiceData: any = [];
function ShipmentBillingNav() {
  const { id: shipmentId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const currentInvoiceId = searchParams.get("invoice");
  const [isCustomBroker] = useCustomBrokerPermission();
  const { isLoading, data: invoices = initialInvoiceData } = useGetShipmentInvoices({
    shipmentId: shipmentId!,
    options: {
      select: useCallback((data: any) => invoiceSelector(data, isCustomBroker), [isCustomBroker]),
      refetchOnMount: false,
    },
  });

  const handleStatusChange = (eventKey: string | null) => {
    searchParams.set("invoice", eventKey || "");
    setSearchParams(searchParams);
  };

  return (
    <div>
      {isLoading && (
        <div className="skeleton-card">
          <Row className="skeleton-row">
            <span key={6} className="skeleton" />
          </Row>
        </div>
      )}
      {!isLoading && invoices?.length && (
        <PillTabs
          id="billing-invoices"
          activeKey={currentInvoiceId || ""}
          onSelect={handleStatusChange}
          tabItems={invoices.map(({ invoice_id, invoice_status }: any) => ({
            eventKey: invoice_id,
            title: (
              <div className="d-flex align-items-center">
                <div>{invoice_id}</div>
                {invoice_status !== "Unsubmitted" && (
                  <div className="ml-2">
                    <Badge
                      type={InvoiceStatusColors[invoice_status] || "secondary"}
                      label={invoice_status}
                      style={{
                        backgroundColor: INVOICE_BADGE_SOLID_COLOR[invoice_status] || "#7E8589",
                        color: "#fff",
                        fontSize: 10,
                      }}
                    />
                  </div>
                )}
              </div>
            ),
          }))}
        />
      )}
    </div>
  );
}

export default ShipmentBillingNav;
